import { Environment } from './environment.interface';
import versionInfo from '../../../version.json';

export const environment: Environment = {
  production: true,

  version: versionInfo.version,

  serverUrl: 'https://assistant-api.ogmatherapy.com',

  links: {
    termsLink: 'https://www.ogmatherapy.com/terms-and-conditions',
    privacyLink: 'https://www.ogmatherapy.com/privacy-policy',
    websiteUrl: 'https://www.ogmatherapy.com',
    supportEmail: 'support@ogmatherapy.com',
  },
};
